import { Component, OnInit } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-geo-group',
  templateUrl: './geo-group.component.html',
  styleUrls: ['./geo-group.component.scss']
})
export class GeoGroupComponent implements OnInit {

  geogroup = [];
  formGroup;
  deletePopupUiData;
  addOrEditLanguage: string;
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private route: Router
    ) { }

    ngOnInit() {
      this.getAllGeoGroup();
    }

    getAllGeoGroup() {
      this.apiService.getHeaders(this.apiConfig.getGeoGroups)
        .subscribe((res: any) => {
          this.geogroup = res.body.data
        }, err => {
          console.log(err);
        })
    }


    showlanguageModal(targetModal){
      this.modalService.open(targetModal, {
        centered: true,
        backdrop: 'static'
      });
    }
    goToAdd(data?){
      if(data == null){
        this.route.navigateByUrl("/hubAdmin/user-management/geo-group/add-edit");
      }else{
        this.route.navigateByUrl("/hubAdmin/user-management/geo-group/add-edit?id="+data);
      }
    }
}
